export const makeExpendituresList = (response) => {
    const expenseList = response.data
        .filter((expenditure) => expenditure.type === 'expense' || expenditure.type === 'output')
        .map((expenditure) => ({
            title: expenditure.title,
            value: expenditure.guid,
            expenditure,
        }));
    const incomeList = response.data
        .filter((expenditure) => expenditure.type === 'income' || expenditure.type === 'input')
        .map((expenditure) => ({
            title: expenditure.title,
            value: expenditure.guid,
            expenditure,
        }));

    return { incomeList, expenseList };
};
